import { CivicBudgetService } from '../openapi';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CivicBudgetListItem } from './civic-budget.common.model';

@Injectable({
  providedIn: 'root'
})
export class CivicBudgetCommonService {
  constructor(private civicBudgetService: CivicBudgetService) {
  }

  loadBudgets(): Observable<CivicBudgetListItem[]> {
    return this.civicBudgetService.getCivicBudgetCollectionCivicBudgetCollection({
      pagination: false
    }).pipe(
      map(v => v.map(item => ({ ...item, tag: `${item.name} ${item.description}` })))
    );
  }
}
